import { render, staticRenderFns } from "./CustomerCase.vue?vue&type=template&id=59fda262&"
import script from "./CustomerCase.vue?vue&type=script&lang=js&"
export * from "./CustomerCase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports